// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"343":"4489ec52","647":"44a91dcd"}[chunkId] + ".chunk.css";
};